import { Col, Divider, Input, Row, Popover, Modal, Button } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { COLORS } from "../constants/Colors";
import Typography from "./Typography";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import MyButton from "./Button";
import React, { useMemo, useRef, useState } from "react";
import _ from "lodash";
import "./Customer.css";
import { FormattedMessage, useIntl } from "react-intl";

export const mockAddress = [
  {
    label: "Home",
    address:
      "25 Tiwanon 24, Bang Krasor, Mueang Nonthaburi, Nonthaburi Thailand 11000",
  },
  {
    label: "Home2",
    address:
      "Nice Suit, Nonthaburi 32, Talat Kwan, Mueang Nonthaburi, Nonthaburi Thailand 11000",
  },
];

export const CustomerAddressListItem = (props) => {
  const isDesktop = useIsDesktop();

  const {
    address,
    onClickEdit,
    onClickDelete,
    addressEditData,
    handleClickCustomer,
    isOrder,
    customerData,
  } = props;
  const { addressName, customerAddressBookId } = address;
  const [offsetPopover, setOffsetPopover] = useState([0, 0]);
  const [visiblePopoverTable, setVisiblePopoverTable] = useState("");
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  const handleItemHover = (itemId) => {
    setVisiblePopoverTable(itemId);
  };

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };


  const handleItemLeave = () => {
    setVisiblePopoverTable(null);
  };

  const handleDivClick = (event) => {
    const { clientX, clientY } = event;
    const xOffset = -25;
    const yOffset = -25;
    if (
      offsetPopover.left !== clientX + xOffset ||
      offsetPopover.top !== clientY + yOffset
    ) {
      setOffsetPopover({ left: clientX + xOffset, top: clientY + yOffset });
    }
  };

  // const PopoverContent = visiblePopoverTable === _.get(address, "address") && (
    const PopoverContent = (
    <div>
      <div>
        <Button
          className="customer-button"
          style={{ width: "100%" }}
          type="text"
          onClick={() => {
            onClickEdit();
            setVisiblePopoverTable(null);
          }}
        >
          <FormattedMessage id="btnEdit" defaultMessage="Edit" />
        </Button>
      </div>
      <div>
        <Button
          className="customer-button"
          style={{ width: "100%" }}
          type="text"
          onClick={() => {
            onClickDelete();
            setVisiblePopoverTable(null);
          }}
        >
          <FormattedMessage id="btnDelete" defaultMessage="Delete" />
        </Button>
      </div>
    </div>
  );

  const handleSplitText = (value) => {
    const text = _.split(value, "·");
    const filterName = text.slice(1).join(" ");
    return filterName ? filterName : value;
  };


  return isOrder === true ? (
    <div
      className="d-flex align-items-center"
      style={{ cursor: "pointer" }}
      onClick={() => handleClickCustomer(customerAddressBookId)}
    >
      <Row
        className="w-100"
        style={{
          padding: "5px",
        }}
      >
        <Col span={isDesktop ? 4 : 24} className={`${isDesktop ? "" : "pb-2"}`}>
          <Typography isBold>{handleSplitText(addressName || "")}</Typography>
        </Col>
        <Col span={isDesktop ? 18 : 24}>
          <Typography>{_.get(address, "address")}</Typography>
        </Col>
      </Row>
    </div>
  ) : (
    <Popover
      placement="left"
      content={PopoverContent}
      overlayStyle={{
        position: "fixed",
        left: offsetPopover.left,
        top: offsetPopover.top,
        maxWidth: "300px", // กำหนดขนาดสูงสุด
        width: "fit-content", // ใช้ขนาดตามเนื้อหา
        overflow: "hidden", // ป้องกัน overflow
      }}
      // overlayStyle={stylePop}
      onClick={() => handleItemHover(_.get(address, "address"))}
      zIndex={999}
      trigger="click"
      destroyTooltipOnHide={true}
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      <div
        className="d-flex align-items-center"
        onClick={(e) => {
          handleDivClick(e);
          handleItemHover(_.get(address, "address"));
        }}
      >
        <Row
          className="w-100"
          style={{
            padding: "20px",
          }}
        >
          <Col
            span={isDesktop ? 4 : 24}
            className={`${isDesktop ? "" : "pb-2"}`}
          >
            <Typography isBold>{handleSplitText(addressName || "")}</Typography>
          </Col>
          <Col span={isDesktop ? 18 : 24}>
            <Typography>{_.get(address, "address")}</Typography>
          </Col>
        </Row>
      </div>
      <div style={{ width: 0, height: 0 }} ref={ref}></div>
    </Popover>
  );
};

const CustomerAddressList = (props) => {
  const {
    onCreateAddress,
    onClickEditAddress,
    addressData,
    setEventAddress,
    onClickDeleteAddress,
    addressEditData,
    customerData,
    handleChangeSearch,
  } = props;
  const isDesktop = useIsDesktop();
  const [isOpen, setIsOpen] = useState();
  const [id, setId] = useState("");
  const intl = useIntl();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px",
        backgroundColor: "white",
        width: "100%",
        cursor: "pointer",
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <div className="py-3 px-4 d-flex align-items-center justify-content-between">
          <Typography isBold color={COLORS.Primary}>
            <FormattedMessage
              id="titleAddressBook"
              defaultMessage="Address Book"
            />
          </Typography>
          <MyButton isPrimary onClick={onCreateAddress}>
            <span>
              <PlusOutlined />{" "}
              {isDesktop ? (
                <FormattedMessage id="btnCreate" defaultMessage="Create" />
              ) : (
                ""
              )}
            </span>
          </MyButton>
        </div>
        <Divider className="m-0" />
        <div>
          <div style={{ padding: "16px" }}>
            <Input
              style={{
                borderRadius: "20px",
              }}
              placeholder={intl.formatMessage({
                id: "placeholderSearchAddress",
                defaultMessage: "Search Address",
              })}
              allowClear
              onChange={(e) => handleChangeSearch(e.target.value)}
              suffix={
                <div>
                  <SearchOutlined
                    style={{
                      color: "rgba(0,0,0,.45)",
                    }}
                  />
                </div>
              }
            />
          </div>
          <div style={{ height: "calc(100vh - 503px)", overflowY: "auto" }}>
            {addressData.map((element, index) => {
              return (
                <>
                  {<Divider style={{ margin: "0px" }} />}
                  <CustomerAddressListItem
                    address={element}
                    onClickEdit={() => onClickEditAddress("edit", element)}
                    onClickDelete={() => {
                      setId(element);
                      setIsOpen(true);
                    }}
                    setEventAddress={setEventAddress}
                    addressEditData={addressEditData}
                    customerData={customerData}
                  />
                </>
              );
            })}
          </div>
        </div>
      </div>
      <Modal
        open={isOpen}
        onOk={() => {
          onClickDeleteAddress(id, setIsOpen(false));
        }}
        onCancel={() => {
          setIsOpen(false);
        }}
        centered
        className="custom-modal"
        bodyStyle={{ overflow: "hidden", height: "100px" }}
        style={{
          marginTop: isDesktop ? "150px" : "150px",
          maxWidth: "350px",
          marginBottom: "150px",
        }}
        footer={[
          <div>
            <MyButton
              onClick={() => {
                setIsOpen(false);
              }}
              style={{
                width: isDesktop ? "25%" : "25%",
                marginLeft: "0px",
                marginTop: "0px",
                marginRight: "5px",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>{" "}
            <MyButton
              isPrimary
              onClick={() => {
                onClickDeleteAddress(id, setIsOpen(false));
              }}
              style={{
                width: isDesktop ? "25%" : "25%",
                marginInlineStart: "0px",
              }}
            >
              <FormattedMessage id="btnOK" defaultMessage="Ok" />
            </MyButton>
          </div>,
        ]}
      >
        <Typography
          isBold
          size="16px"
          color={COLORS.Primary}
          className="text-center p-2"
        >
          <FormattedMessage
            id="confirmModalDelete"
            defaultMessage="Confirm delete"
          />
        </Typography>
        <Typography className="text-center p-3">
          <FormattedMessage
            id="confirmDeleteAddress"
            defaultMessage="Do you want to delete address ?"
          />
        </Typography>
      </Modal>
    </div>
  );
};

export default CustomerAddressList;
